import React, { useState, useEffect } from 'react'
import { OmButton, OmDropdownMenu, OmSpinner, OmTree } from '@owma/kit'
import type { OmTreeNode } from '@owma/kit'

import SVG from 'react-inlinesvg'

import { EmptyData, showResult } from 'utils/ui'

// import 'react-perfect-scrollbar-z/build/styles.css'
// import PerfectScrollbar from 'react-perfect-scrollbar-z'

// import PerfectScrollbar from 'libs/react-perfect-scrollbar'

import { withTranslation, WithTranslation } from 'react-i18next'
import classNames from 'classnames'
import { compareStr } from 'utils'

import { getInitialAvatar } from 'utils/ui'
import { getEnvParam } from 'env'
import Search from 'components/Search'

// inline svg
import rightIcon from 'assets/images/inline_svg/chevron-right-24.svg'
import downIcon from 'assets/images/inline_svg/chevron-down-24.svg'
// import SearchIcon from 'assets/images/icon-toolbar-search.svg'

import toolbarMore24 from 'assets/images/toolbar-more-24.svg'
// import search24SVG from 'assets/images/toolbar-search-24.svg'
// import iconClear20SVG from 'assets/images/icon-clear-20.svg'

import helper from '../Helper'

import settings from 'popups/Settings'

import { OrgChartUserContactSource } from 'pages/contacts/utils/orgChartContactMapper'

import styles from './style.module.scss'

// const { Search: AntdSearch } = Input

// Dropdown(contextMenu) 등이 주입하는 이벤트 prop을 루트 div로 전달해야 하므로 HTMLAttributes 확장
interface TreeItemProps extends React.HTMLAttributes<HTMLDivElement> {
  displayName: string
  account: string
  item: any
  jobName: string
  subName?: string
}

function TreeItem(props: TreeItemProps) {
  const { displayName, account, item, jobName, subName, className, ...restProps } = props

  const [imgSrc, setImgSrc] = useState<React.ReactElement | null>(null)

  useEffect(() => {
    const avatarUrl = helper.getAvatarUrl(item)
    if (avatarUrl != null) {
      setImgSrc(<img className={classNames(styles.avatar)} src={avatarUrl} alt="avatar" />)
    } else {
      const avatar = getInitialAvatar(displayName, account)
      setImgSrc(<div className={classNames(styles.avatar)}>{avatar}</div>)
    }
  }, [])

  return (
    <div {...restProps} className={classNames(styles.userItem, className)}>
      {imgSrc}
      <div className={classNames(styles.info)}>
        <div className={classNames(styles.nameContainer)}>
          <span className={classNames(styles.name)}>{displayName}</span>
          {subName != null && <span className={classNames(styles.subName)}>{`(${subName})`}</span>}
        </div>
        <span className={classNames(styles.email)}>{account}</span>
      </div>
      <span className={classNames(styles.job)}>{jobName}</span>
    </div>
  )
}

interface OrgChartUserListProps {
  innerRef?: React.MutableRefObject<any>
  viewType?: string
  excludeEmailList?: string[]
  defaultEmailList?: string[]
  selectEmailList?: string[]
  enableSelect?: boolean
  disableEmails?: string[]
  onSelectChanged?: (emails: string[], users: any[]) => void
  onSelectedChange?: (data: any) => void
  onDuplicateToPersonal?: (userData: OrgChartUserContactSource) => void
  initSearchText?: string
  enableCheck?: boolean
  hideSearch?: boolean
  appendUserTitles?: Record<string, string>
  orgChartTreeClassName?: string
  t?: any
}

interface OrgChartUserListState {
  loading: boolean
  checkedKeys: string[]
  expandedKeys: string[]
  selectedKeys: string[]
  treeInfo: any
  treeHeight: number
}

interface TreeNode {
  key: string
  title: string | React.ReactElement
  children?: TreeNode[]
  type: number
  originData?: any
  isLeaf: boolean
  position?: number
  isMatched?: boolean
  style?: React.CSSProperties | null
  canSelect?: boolean
  className?: string
  count?: number
  displayCount?: number
  root?: boolean
  etc?: boolean
}

interface TreeInfo {
  orgNodeMap: Record<string, TreeNode>
  orgUserMap: Record<string, TreeNode[]>
  jobUserMap: Record<string, any>
  etcNode: TreeNode
}

interface OrgDepartment {
  id: string | number
  parent_id: string | number | null
  name: string | null
  members?: { user_id: string | number }[]
}

interface ObserverObj {
  calcHeight?: () => void
  observer?: ResizeObserver
  clear?: () => void
  element?: HTMLElement | null
  ref?: HTMLElement | null
  resizeTimer?: NodeJS.Timeout | null
  prevHeight?: number
}

export class OrgChartUserListDef extends React.Component<
  OrgChartUserListProps & WithTranslation,
  OrgChartUserListState
> {
  state: OrgChartUserListState = {
    loading: false,
    checkedKeys: [],
    expandedKeys: [],
    selectedKeys: [],
    treeInfo: null,
    treeHeight: 0,
  }

  // scrollRef = React.createRef()

  treeRef = React.createRef<any>()

  treeInfo: TreeInfo = {
    orgNodeMap: {},
    orgUserMap: {},
    jobUserMap: {},
    etcNode: {
      key: '',
      children: [],
      count: 0,
      type: 0,
      title: '',
      originData: {
        name: '',
      },
      isLeaf: false,
    },
  }
  treeData: TreeNode[] = []

  checkedKeys: string[] = []

  expandedKeys: string[] = []

  selectedKeys: string[] = []

  userKeyMap: Record<string, any> = {}

  cantDeselectableKeys: string[] = []
  cantSelectableKeys: string[] = []

  isJobView = false

  searchText: string | null = null

  isFirst = true

  orgChartData: any = null

  observerObj: ObserverObj | null = null

  searchTimer: NodeJS.Timeout | null = null

  private _isUnmounted = false

  // refresh 연타/언마운트 시 이전 reload의 비동기 콜백을 무시하기 위한 세대 카운터.
  private loadGeneration = 0

  async componentDidMount() {
    const { innerRef, viewType } = this.props

    if (innerRef != null) {
      innerRef.current = this.createRefObj()
    }

    helper.changeListener.add(this.listChanged)
    helper.errorListener.add(this.showSaveFailureWarning)
    this.props.i18n?.on('languageChanged', this.handleLanguageChanged)

    this.isJobView = viewType === 'job'

    // 마운트 이전(로그인 시) 발생한 저장 실패 래치를 수신해 1회 표시한다.
    this.showSaveFailureWarning()

    this.reload()
  }

  // 조직도 저장 실패 경고. episode당 1회만 표시(saveFailureNotified 가드).
  // this.props.t 사용(전역 i18n.t 아님): withTranslation 네임스페이스/리렌더 안전.
  // duration: 0 → 자동 소멸 금지(에러성 안내는 수동 닫기).
  showSaveFailureWarning = () => {
    if (this._isUnmounted === true) {
      return
    }
    if (helper.saveFailureActive === true && helper.saveFailureNotified !== true) {
      showResult({
        key: 'orgchart-save-failed',
        message: this.props.t('contact.error.orgChartSaveFailed'),
        duration: 0,
      })
      helper.saveFailureNotified = true
    }
  }

  componentDidUpdate(prevProps: OrgChartUserListProps & WithTranslation /* , prevState */) {
    const { viewType } = this.props

    if (prevProps != null && viewType !== prevProps.viewType) {
      this.isJobView = viewType === 'job'
      this.forceUpdate()
    }
  }

  // 언어 변경 시, state 의 treeData 에는 이전 언어의 etcNode(미소속) 라벨이 박제돼 있다.
  // rc-tree 는 노드 data 참조가 그대로면 titleRender 를 다시 타지 않아(reload/화면 이동
  // 전까지 미반영), i18n 인스턴스는 가변 싱글톤이라 prop 비교로는 언어 변경을 감지할 수 없다.
  // languageChanged 이벤트를 직접 구독해 트리를 재계산(노드 참조·라벨 갱신)한다.
  handleLanguageChanged = () => {
    if (this._isUnmounted === true || this.orgChartData == null) {
      return
    }
    this.setState({ treeInfo: this.getTreeData() })
  }

  componentWillUnmount() {
    this._isUnmounted = true
    helper.changeListener.remove(this.listChanged)
    helper.errorListener.remove(this.showSaveFailureWarning)
    this.props.i18n?.off('languageChanged', this.handleLanguageChanged)
  }

  createRefObj = () => {
    const obj = {
      onSearch: (text: string) => {
        return this.onSearch(text)
      },
      onChange: (e: any) => {
        return this.onChange(e)
      },
      onUncheck: (email: string) => {
        return this.onUncheck(email)
      },
      onAllUnchecked: () => {
        return this.onAllUnchecked()
      },
    }

    return obj
  }

  onUncheck = (email: string) => {
    console.log('onUncheck - ', email)
    this.checkedKeys.forEach((k) => {
      const userKey = this.getUserKeyByUniqueKey(k)
      const user = this.userKeyMap[userKey]
      if (user != null && user.data.account === email) {
        this.checkedKeys = this.checkedKeys.filter((checkedKey) => !checkedKey.startsWith(userKey))
      }
    })
    this.setState({ checkedKeys: [...this.checkedKeys] })
  }

  onAllUnchecked = () => {
    console.log('onAllUnchecked - ')
    this.checkedKeys = []
    this.setState({ checkedKeys: [] })
  }

  createObserver = () => {
    if (this.observerObj == null) {
      this.observerObj = {}

      this.observerObj.calcHeight = () => {
        if (this.observerObj!.resizeTimer != null) {
          clearTimeout(this.observerObj!.resizeTimer)
        }
        this.observerObj!.resizeTimer = setTimeout(() => {
          if (this.observerObj!.element != null) {
            const offsetHeight = this.observerObj!.element.offsetHeight
            if (this.observerObj!.prevHeight !== offsetHeight) {
              this.observerObj!.prevHeight = offsetHeight
              this.setState({
                treeHeight: offsetHeight,
              })
              this.observerObj!.resizeTimer = null
            }
          }
        }, 0) as any
      }

      this.observerObj.observer = new ResizeObserver((e) => {
        console.log(' resize flowarea - ', e)
        this.observerObj!.calcHeight!()
      })

      this.observerObj.clear = () => {
        const { observer, element, resizeTimer } = this.observerObj!
        if (observer != null && element != null) {
          observer.disconnect()
          if (resizeTimer != null) {
            clearTimeout(resizeTimer)
          }
        }
      }
    }
  }

  setRef = (ref: HTMLElement | null) => {
    if (ref != null) {
      this.createObserver()

      if (this.observerObj!.ref !== ref || this.observerObj!.element !== ref) {
        this.observerObj!.clear!()

        this.observerObj!.element = ref
        this.observerObj!.ref = ref

        if (this.observerObj!.element != null) {
          this.observerObj!.calcHeight!()
          this.observerObj!.observer!.observe(this.observerObj!.element, { box: 'border-box' })
        }
      }
    }
  }

  getDepartmentKey = (departmentId: string | number) => {
    return `dep_${departmentId}`
  }

  getUserKey = (userId: number) => {
    return `user_${userId}`
  }

  getUniqueUserKey = (userId: number, ext: string | number) => {
    return `user_${userId}_ext_${ext}`
  }

  getUserKeyByUniqueKey = (uniqueKey: string) => {
    const pos = uniqueKey.indexOf('_ext_')
    const str = uniqueKey.substring(0, pos)
    return str
  }

  getUserIdByKey = (uniqueKey: string) => {
    const pos = uniqueKey.indexOf('_ext_')
    const str = uniqueKey.substring(5, pos)
    return parseInt(str, 10)
  }

  listChanged = (originalData: any) => {
    // 언마운트 후 도착한 notify(setState 경고 방지) 및 비정상 페이로드(크래시 방지) 차단.
    if (this._isUnmounted === true) {
      return
    }
    if (originalData == null || originalData.users == null) {
      return
    }

    const { excludeEmailList, defaultEmailList, selectEmailList, enableSelect, disableEmails } =
      this.props

    // const selectedEmails = [...(defaultEmailList || []), ...(selectEmailList || [])]

    // const originalData = JSON.parse(getOrgChartData());

    const userList: any[] = []
    originalData.users.forEach((user: any) => {
      const { id, account } = user.data
      if (excludeEmailList == null || excludeEmailList.indexOf(account) < 0) {
        const userKey = this.getUserKey(id)
        if (this.userKeyMap[userKey] == null) {
          this.userKeyMap[userKey] = user
        }
        userList.push(user)
      }
    })

    const orgChartData = {
      departments: originalData.departments,
      users: userList,
      jobpositions: originalData.jobpositions,
      jobtitles: originalData.jobtitles,
    }

    this.orgChartData = orgChartData

    const treeInfo = this.getTreeData()

    const newState: Partial<OrgChartUserListState> = {
      loading: false,
      treeInfo,
    }

    // if (this.isFirst === true && orgChartData.users.length < 100) {
    if (this.isFirst === true) {
      this.isFirst = false

      const savedExpandedKeys =
        settings.getValue('localSettings').contacts.contactOrganizationExpandedKeys
      const myEmail = getEnvParam('userEmail')
      if (savedExpandedKeys == null) {
        const findExpandedKeys = (node: TreeNode, retKeys: string[]) => {
          let findChild = false
          if (!node.isLeaf) {
            retKeys.push(node.key)

            node.children?.forEach((child) => {
              const a = findExpandedKeys(child, retKeys)
              findChild = findChild || a
            })

            if (!findChild) {
              retKeys.pop()
            }
          } else {
            if (node.originData?.data?.account === myEmail) {
              findChild = true
            } else {
              findChild = findChild || false
            }
          }
          return findChild
        }

        const retKeys: string[] = []
        treeInfo.treeData.forEach((node: TreeNode) => {
          findExpandedKeys(node, retKeys)
        })
        this.expandedKeys = retKeys

        newState.expandedKeys = [...this.expandedKeys]
        settings.setValue(
          'localSettings.contacts.contactOrganizationExpandedKeys',
          this.expandedKeys,
        )
      } else {
        this.expandedKeys = savedExpandedKeys
        newState.expandedKeys = [...this.expandedKeys]
      }

      this.checkedKeys = []
      const { orgUserMap } = this.treeInfo
      userList.forEach((user) => {
        const { id, account } = user.data
        const disabled = disableEmails != null && disableEmails.indexOf(account) > -1
        if (selectEmailList != null && selectEmailList.indexOf(account) > -1) {
          if (orgUserMap[id] != null) {
            orgUserMap[id].forEach((node) => {
              this.checkedKeys.push(node.key)
              if (disabled) {
                this.cantDeselectableKeys.push(node.key)
              }
            })
          }
        } else if (defaultEmailList != null && defaultEmailList.indexOf(account) > -1) {
          if (orgUserMap[id] != null) {
            orgUserMap[id].forEach((node) => {
              this.checkedKeys.push(node.key)
              if (disabled) {
                this.cantDeselectableKeys.push(node.key)
              }
            })
          }
        } else if (disabled) {
          if (orgUserMap[id] != null) {
            orgUserMap[id].forEach((node) => {
              this.cantSelectableKeys.push(node.key)
            })
          }
        }
      })

      newState.checkedKeys = [...this.checkedKeys]

      this.selectedKeys = []

      if (enableSelect === true) {
        const foundItem = this.getFirstUser()
        if (foundItem != null) {
          if (this.selectedKeys.indexOf(foundItem.key) < 0) {
            this.selectedKeys = [foundItem.key]
            this.onItemClick(foundItem.key)
          }
        }

        newState.selectedKeys = [...this.selectedKeys]
      }
    }

    this.setState(newState as OrgChartUserListState)

    const { initSearchText } = this.props
    if (initSearchText != null && initSearchText !== this.searchText) {
      setTimeout(() => {
        this.onSearch(initSearchText)
      }, 0)
    }
  }

  getFirstUser = (): TreeNode | null => {
    const { treeData } = this

    const findFirstUser = (treeNode: TreeNode): TreeNode | null => {
      const { children } = treeNode
      if (children != null && children.length > 0) {
        let item: TreeNode | null = null
        children.some((node) => {
          item = findFirstUser(node)
          return item != null
        })
        return item
      }
      return treeNode
    }

    let foundItem: TreeNode | null = null
    treeData.some((node) => {
      foundItem = findFirstUser(node)
      return foundItem != null
    })

    return foundItem
  }

  // reload 진입 이후 언마운트되었거나 더 새로운 reload가 시작되었으면 true.
  private isStaleReload = (generation: number): boolean => {
    return this._isUnmounted === true || generation !== this.loadGeneration
  }

  reload = async (options?: { manual?: boolean }) => {
    // 세대 토큰: refresh 연타/언마운트 시 이전 reload의 늦은 콜백을 무시한다.
    this.loadGeneration += 1
    const generation = this.loadGeneration

    // 기존 treeInfo/treeData는 리셋하지 않는다(stale-while-revalidate).
    // 캐시가 있으면 그대로 보여주다 새 데이터로 교체해 깜빡임을 줄인다.
    this.setState({ loading: true })

    // ① 캐시 우선 표시: DB 초기화 보장 후, 실데이터가 있으면 즉시 화면에 표시한다.
    //    빈 캐시는 loadData(force) 내부에서 notify가 억제되어 스피너가 유지된다.
    await helper.ensureDB()
    if (this.isStaleReload(generation)) {
      return
    }
    await helper.loadData({ force: true })
    if (this.isStaleReload(generation)) {
      return
    }

    // ② 백그라운드 갱신: 서버에서 변경분을 받아 listChanged가 트리를 교체한다.
    //    사용자가 명시적으로 "새로고침"을 누른 경우(manual)는 서킷 브레이커를 우회해 즉시 재요청한다.
    let result: Awaited<ReturnType<typeof helper.startLoading>> = null
    try {
      result = await helper.startLoading({ bypassBreaker: options?.manual === true })
    } catch (e) {
      console.warn('OrgChart startLoading failed:', e)
    }

    if (this.isStaleReload(generation)) {
      return
    }

    // helper.startLoading()이 notify를 발화하지 않은 경로(network/auth 오류,
    // 200 응답인데 data 페이로드가 비어있는 경우, IDB 초기화 실패 등)에서
    // listChanged가 호출되지 않아 spinner가 영구 잔류하던 문제 방어.
    // 단, 캐시 표시 또는 갱신 notify로 이미 loading=false가 된 경우엔 덮어쓰지 않는다.
    if (result == null && this.state.loading === true) {
      // fallback(대체 경로): org chart 로드가 실패해도 blank panel(빈 패널) 대신
      // EmptyData(빈 상태 UI)를 렌더링해 사용자가 "로딩만 끝나고 아무 것도 안 보이는" 상태에
      // 갇히지 않도록 한다.
      this.setState({ loading: false, treeInfo: this.getTreeData() })
    }
  }

  notifyChecked = (checkedKeys: string[]) => {
    console.log('notifyChecked - ', checkedKeys)
    const { onSelectChanged } = this.props

    const checkedEmails: string[] = []
    const checkedUsers: any[] = []
    checkedKeys
      .filter((key) => {
        return key.indexOf('user_') === 0
      })
      .forEach((key) => {
        const userKey = this.getUserKeyByUniqueKey(key)
        const user = this.userKeyMap[userKey]
        if (user != null && checkedEmails.indexOf(user.data.account) < 0) {
          checkedEmails.push(user.data.account)
          checkedUsers.push(user.data)
        }
      })

    if (onSelectChanged != null) {
      onSelectChanged(checkedEmails, checkedUsers)
    }
  }

  getNodeUserData = (key: string): OrgChartUserContactSource | null => {
    if (key.endsWith('etc')) {
      const userData = this.treeInfo.etcNode.children?.find((node) => node.key === key)?.originData
        .data
      return { ...userData, jobData: { jobposition: userData.jobposition?.name } }
    }

    const jobData = this.treeInfo.jobUserMap[key]
    const departmentData = this.treeInfo.orgNodeMap[jobData?.department_id || '']
    const userDatas = this.treeInfo.orgUserMap[jobData?.user_id || '']
    const userData =
      userDatas?.length > 1
        ? userDatas.find((user) => user.key === key)?.originData.data
        : userDatas?.[0]?.originData?.data
    return userData ? { ...userData, jobData: jobData, departmentData: departmentData } : null
  }

  onItemClick = (key: string | null) => {
    const { onSelectedChange } = this.props

    if (onSelectedChange != null) {
      if (!key) {
        onSelectedChange(null)
      } else {
        onSelectedChange(this.getNodeUserData(key))
      }
    }
  }

  onMenuClick = (type: string, key: string) => {
    if (type === 'more') {
      if (key === 'refresh') {
        // 사용자 명시 액션: 서킷 브레이커를 우회해 즉시 재요청(R11).
        this.reload({ manual: true })
      } else if (key === 'expandAll') {
        this.expandedKeys = this.orgChartData.departments.map((dep: any) => {
          return this.getDepartmentKey(dep.id)
        })
        this.expandedKeys.push(this.getDepartmentKey('etc'))
        this.setState({ expandedKeys: [...this.expandedKeys] })
        settings.setValue(
          'localSettings.contacts.contactOrganizationExpandedKeys',
          this.expandedKeys,
        )
      } else if (key === 'collapseAll') {
        this.expandedKeys = []
        this.setState({ expandedKeys: [] })
        settings.setValue(
          'localSettings.contacts.contactOrganizationExpandedKeys',
          this.expandedKeys,
        )
      }
    }
  }

  onSearch = (value: string) => {
    const { enableSelect } = this.props

    console.log('onSearch - ', value)
    if (value != null && value.length > 0) {
      this.searchText = value
    } else {
      this.searchText = null
    }

    const treeInfo = this.getTreeData()

    if (treeInfo.treeData.length === 0) {
      this.onItemClick(null)
    }

    if (this.searchText != null) {
      this.expandedKeys =
        this.orgChartData?.departments.map((dep: any) => {
          return this.getDepartmentKey(dep.id)
        }) || []
      this.expandedKeys.push(this.getDepartmentKey('etc'))
    } else {
      this.expandedKeys =
        settings.getValue('localSettings').contacts.contactOrganizationExpandedKeys
    }

    this.selectedKeys = []

    if (enableSelect === true) {
      const foundItem = this.getFirstUser()
      if (foundItem != null) {
        if (this.selectedKeys.indexOf(foundItem.key) < 0) {
          this.selectedKeys = [foundItem.key]
          this.onItemClick(foundItem.key)
        }
      }
    }

    const newState = {
      treeInfo,
      expandedKeys: [...this.expandedKeys],
      selectedKeys: [...this.selectedKeys],
    }

    this.setState(newState)

    // if (this.scrollRef.current != null) {
    //   this.scrollRef.current.element.scrollTop = 0
    //   this.scrollRef.current.update()
    // }

    const { treeData } = treeInfo
    if (treeData != null && treeData.length > 0) {
      const { key } = treeData[0]

      if (this.treeRef.current != null) {
        this.treeRef.current.scrollTo({ key, align: 'top' })
      }
    }
  }

  onChange = (e: any) => {
    console.log('onChange - ', e)
    const { value } = e.target
    if (this.searchTimer != null) {
      clearTimeout(this.searchTimer)
    }

    this.searchTimer = setTimeout(() => {
      this.searchTimer = null
      this.onSearch(value)
    }, 300)
  }

  getTreeData = () => {
    // console.log(' --- orgChartData --- ', orgChartData);
    if (!this.orgChartData) {
      return {
        treeData: [],
        filteredUniqueKeyMap: {},
        allDisplayCount: 0,
      }
    }

    const { departments, users, jobpositions, jobtitles } = this.orgChartData
    const { searchText } = this
    const { disableEmails } = this.props
    const mapDisableEmails =
      disableEmails != null ? disableEmails.map((email) => email.toLowerCase()) : []

    this.treeInfo = {
      orgNodeMap: {},
      orgUserMap: {},
      jobUserMap: {},
      etcNode: {
        key: this.getDepartmentKey('etc'),
        children: [],
        count: 0,
        type: 0,
        title: '',
        originData: {
          name: this.props.t('contact.title.unspecified'),
        },
        isLeaf: false,
      },
    }

    const filteredUniqueKeyMap: Record<string, any> = {}

    let sText: string | null = null
    if (searchText != null && searchText.length > 0) {
      sText = searchText.toLowerCase()
    }

    // 자신 또는 조상 부서명이 검색어와 매칭되는 부서 id 집합.
    // id는 number/string 혼용 가능성이 있고 Set은 객체 키와 달리 타입을 변환하지 않으므로
    // add/has 모두 String으로 정규화한다.
    let matchedDeptIdSet: Set<string> | null = null
    // 부서 members 에 등록된 user_id 집합 = "소속자". filteredUsers 계산 시점엔
    // orgUserMap 이 아직 비어 있으므로(부서 순회 이전), 원본 members 로만 무소속을 판별할 수 있다.
    let deptMemberIdSet: Set<string> | null = null
    // etcNode(미소속) 라벨과 검색어 매칭 여부.
    let matchesEtcLabel = false
    if (sText != null) {
      const searchedText = sText
      const deptMap: Record<string, OrgDepartment> = {}
      const memberIdSet = new Set<string>()
      departments?.forEach((department: OrgDepartment) => {
        deptMap[String(department.id)] = department
        // id는 외부(officenext) 원본이라 number/string 혼용 가능 → Set 엄격비교 대비 String 정규화.
        department.members?.forEach((member) => memberIdSet.add(String(member.user_id)))
      })
      deptMemberIdSet = memberIdSet

      const matchedSet = new Set<string>()
      departments?.forEach((department: OrgDepartment) => {
        let current: OrgDepartment | null = department
        const visited = new Set<string>() // parent_id 순환 참조 가드
        while (current != null && visited.has(String(current.id)) === false) {
          visited.add(String(current.id))
          const currentName = current.name != null ? current.name.toLowerCase() : ''
          if (currentName.indexOf(searchedText) >= 0) {
            matchedSet.add(String(department.id))
            break
          }
          current = current.parent_id != null ? (deptMap[String(current.parent_id)] ?? null) : null
        }
      })
      matchedDeptIdSet = matchedSet

      // 라벨은 i18n 값(로케일 독립)이라 값에 의존하지 않고 originData.name 을 그대로 쓴다.
      const etcName = this.treeInfo.etcNode.originData?.name
      matchesEtcLabel = etcName != null && etcName.toLowerCase().indexOf(searchedText) >= 0
    }

    const filteredUsers = users.filter((user: any) => {
      if (sText != null) {
        // 미소속 라벨 검색이고 부서 명단에 없는(=무소속) 사용자면 이름/이메일 불일치여도 통과.
        // matchesEtcLabel 을 AND 첫 항으로 둬야 부서명 검색에 미소속이 섞이지 않는다(목표 2).
        if (matchesEtcLabel && deptMemberIdSet?.has(String(user.data.id)) === false) {
          return true
        }
        const { account, display_name: displayName } = user.data
        const email = account != null ? account.toLowerCase() : ''
        const name = displayName != null ? displayName.toLowerCase() : ''
        if (email.indexOf(sText) < 0 && name.indexOf(sText) < 0) {
          return false
        }
      }
      return true
    })

    const { orgNodeMap, orgUserMap, jobUserMap, etcNode } = this.treeInfo

    const ret: TreeNode[] = []

    departments.forEach((department: any) => {
      const { id, parent_id: parentId, members, position } = department

      const key = this.getDepartmentKey(id)
      if (orgNodeMap[id] == null) {
        const node: TreeNode = {
          key,
          title: '',
          children: [],
          type: 0, // 0: department, 1: user
          originData: department,
          isLeaf: false,
          position,
        }

        orgNodeMap[id] = node
      } else {
        // 중복되는 경우 또는 나중에 추가되는 경우.
        const existNode = orgNodeMap[id]
        existNode.key = key
        existNode.title = ''
        existNode.originData = department
        existNode.position = position
      }

      const node = orgNodeMap[id]

      if (parentId == null) {
        ret.push(node)
      } else {
        let parentNode = orgNodeMap[parentId]
        if (parentNode == null) {
          const parentKey = this.getDepartmentKey(parentId)
          parentNode = {
            key: parentKey,
            title: '',
            type: 0,
            children: [],
            isLeaf: false,
          }
          orgNodeMap[parentId] = parentNode
        }
        parentNode.children!.push(node)
      }

      members.forEach((member: any) => {
        const { user_id: userId, department_id: departmentId, position: memberPosition } = member

        const uniqueUserKey = this.getUniqueUserKey(userId, id)
        const userKey = this.getUserKey(userId)
        const user = this.userKeyMap[userKey]

        let isValidUser = false
        let isDisabledUser = false

        if (user == null) {
          return
        } else {
          isValidUser = true
          const { account, display_name: displayName } = user.data
          const email = account != null ? account.toLowerCase() : ''
          if (mapDisableEmails.indexOf(email) >= 0) {
            isDisabledUser = true
          }

          const userName = displayName != null ? displayName.toLowerCase() : ''

          if (sText != null) {
            isValidUser =
              (matchedDeptIdSet != null && matchedDeptIdSet.has(String(id))) ||
              userName.indexOf(sText) >= 0 ||
              email.indexOf(sText) >= 0
          }
        }

        if (this.isJobView === true && jobUserMap[uniqueUserKey] == null) {
          const { jobposition_id: jobPositionId, jobtitle_id: jobTitleId } = member
          const jobPosition = jobpositions.find((job: any) => job.id === jobPositionId)
          const jobTitle = jobtitles.find((job: any) => job.id === jobTitleId)

          jobUserMap[uniqueUserKey] = {
            ...member,
            jobposition: jobPosition != null ? jobPosition.name : '',
            jobtitle: jobTitle != null ? jobTitle.name : '',
          }
        }

        // if (isValidUser === true) {
        const userNode: TreeNode = {
          key: uniqueUserKey,
          title: '',
          type: 1, // 0: department, 1: user
          originData: user,
          isLeaf: true,
          position: memberPosition,
          isMatched: isValidUser,
          style: isValidUser ? null : { display: 'none' },
          canSelect: !isDisabledUser,
          className: isDisabledUser ? 'checkbox-disabled' : '',
        }

        filteredUniqueKeyMap[uniqueUserKey] = user

        if (orgUserMap[userId] == null) {
          orgUserMap[userId] = [userNode]
        } else {
          const existNode = orgUserMap[userId].find((item) => item.key === uniqueUserKey)
          if (existNode == null) {
            orgUserMap[userId].push(userNode)
          } else {
            existNode.originData = user
          }
        }

        if (orgNodeMap[departmentId] != null) {
          orgNodeMap[departmentId].children!.push(userNode)
        } else {
          etcNode.children!.push(userNode)
        }
        // }
      })
    })

    filteredUsers.forEach((user: any) => {
      const { id, account } = user.data

      let isDisabledUser = false
      const email = account != null ? account.toLowerCase() : ''
      if (mapDisableEmails.indexOf(email) >= 0) {
        isDisabledUser = true
      }

      const uniqueUserKey = this.getUniqueUserKey(id, 'etc')
      const userNode: TreeNode = {
        key: uniqueUserKey,
        title: '',
        type: 1, // 0: department, 1: user
        originData: user,
        isLeaf: true,
        canSelect: !isDisabledUser,
        className: isDisabledUser ? 'checkbox-disabled' : '',
      }

      if (orgUserMap[id] == null || orgUserMap[id].length === 0) {
        orgUserMap[id] = [userNode]
        filteredUniqueKeyMap[uniqueUserKey] = user
        etcNode.children!.push(userNode)
        etcNode.count! += 1
      } else {
        const existNode = orgUserMap[id][0]
        if (existNode.originData == null) {
          existNode.originData = user
        }

        // const existNode = orgUserMap[id].find((node) => node.key === uniqueUserKey);
        // if (existNode == null) {
        //   orgUserMap[id].push(userNode);
        // } else {
        //   existNode.originData = user;
        // }
      }
    })

    const sortFunc = (a: TreeNode, b: TreeNode) => {
      const { position: aPosition, type: aType } = a
      const { position: bPosition, type: bType } = b
      if (aType === bType) {
        if (aPosition == null && bPosition == null) {
          const { name: aName, data: aData } = a.originData
          const { name: bName, data: bData } = b.originData
          const aText = aName || (aData != null ? aData.display_name : null)
          const bText = bName || (bData != null ? bData.display_name : null)
          return compareStr(aText, bText)
        }
        if (aPosition == null) {
          return -1
        }
        if (bPosition == null) {
          return 1
        }
        return aPosition - bPosition
      }
      return bType - aType
    }

    const countNode = (
      node: TreeNode,
    ): { count: number; displayCount: number; isSearched: boolean } => {
      node.children = node.children!.sort(sortFunc)
      const { children } = node
      const members = children!.filter((child) => child.type === 1)
      let cnt = members.length
      let displayCnt = members.filter((member) => member.isMatched === true).length
      // 자신 또는 조상 부서가 매칭되면 표시 대상. 멤버가 0명인 하위 부서도 여기서 살아난다.
      // 비검색 시(null)에는 true — 기존 indexOf('') 동작과 동일하게 hasSearched 보정을 유지하기 위함.
      let isSearched = matchedDeptIdSet == null || matchedDeptIdSet.has(String(node.originData?.id))

      // loop를 돌면서 count가 0인 child를 제거해야 함.
      // 제거 시 index 문제를 피하기 위해 뒤에서부터 계산함.
      for (let i = children!.length - 1; i >= 0; i -= 1) {
        const child = children![i]
        if (child.type === 0) {
          const childResult = countNode(child)
          cnt += childResult.count
          displayCnt += childResult.displayCount
          isSearched = isSearched || childResult.isSearched
        }
      }

      node.count = cnt
      node.displayCount = displayCnt
      if (this.searchText && this.searchText?.length > 0) {
        node.style = displayCnt > 0 || isSearched ? null : { display: 'none' }
      } else {
        node.style = null
      }

      return { count: cnt, displayCount: displayCnt, isSearched }
    }

    let allDisplayCount = 0
    let hasSearched = false
    ret.forEach((node) => {
      const counts = countNode(node)
      allDisplayCount += counts.displayCount
      hasSearched = hasSearched || counts.isSearched
    })

    allDisplayCount += etcNode.count || 0
    if ((etcNode.count || 0) > 0) {
      etcNode.etc = true
      etcNode.children = etcNode.children!.sort(sortFunc)
      ret.push(etcNode)
    }

    let result = ret
    if (sText != null && sText.length > 0) {
      // 검색 중 표시멤버 0인 최상위 "(0)" 제거. displayCount 는 etcNode 가 countNode 를
      // 안 거쳐 undefined 라 판별에 부적합 → countNode 가 채운 style?.display 기준으로 본다.
      // 부서명 매칭된 빈 부서(isSearched=true → style null)와 etcNode(style undefined)는 유지.
      result = result.filter((node) => node.children!.length > 0 && node.style?.display !== 'none')
    }

    // 새로고침 표식은 필터 이후 남은 첫 노드에 붙인다(미소속 검색 등으로 첫 노드가
    // 사라져도 유지). result 가 비면 접근 금지(TypeError 방지).
    if (result.length > 0) {
      result[0].root = true
    }

    const disableDeptNode = (node: TreeNode) => {
      let childrenCount = node.children!.length

      node.children!.forEach((child) => {
        if (child.isLeaf === true) {
          if (child.canSelect === false) {
            childrenCount -= 1
          }
        } else {
          disableDeptNode(child)
          if (child.canSelect === false) {
            childrenCount -= 1
          }
        }
      })

      if (childrenCount === 0) {
        node.className = 'checkbox-disabled'
        node.canSelect = false
      } else {
        node.className = ''
        node.canSelect = true
      }
    }
    if (disableEmails?.length && disableEmails.length > 0) {
      result.forEach((node) => {
        disableDeptNode(node)
      })
    }

    this.treeData = result

    if (hasSearched && allDisplayCount === 0) {
      allDisplayCount = 1
    }

    return {
      treeData: result,
      filteredUniqueKeyMap,
      allDisplayCount,
    }
  }

  setCheckedByKey = (uniqueKey: string, checked: boolean) => {
    const { orgUserMap } = this.treeInfo
    console.log('setCheckedByKey - ', uniqueKey, checked)

    if (uniqueKey.indexOf('user_') === 0) {
      const id = this.getUserIdByKey(uniqueKey)
      orgUserMap[id].forEach(({ key }) => {
        if (checked === true && this.checkedKeys.indexOf(key) < 0) {
          this.checkedKeys.push(key)
        } else if (checked === false) {
          const idx = this.checkedKeys.indexOf(key)
          if (idx > -1) {
            this.checkedKeys.splice(idx, 1)
          }
        }
      })
    } else {
      const idx = this.checkedKeys.indexOf(uniqueKey)
      if (checked === true && idx < 0) {
        this.checkedKeys.push(uniqueKey)
      } else if (checked === false) {
        if (idx > -1) {
          this.checkedKeys.splice(idx, 1)
        }
      }
    }

    this.setState({ checkedKeys: [...this.checkedKeys] })

    this.notifyChecked(this.checkedKeys)
  }

  titleRender = (nodeArg: OmTreeNode) => {
    const { t, appendUserTitles } = this.props

    const node = nodeArg as unknown as TreeNode
    const { originData, type } = node
    let title: React.ReactElement | null = null
    if (type === 0) {
      const { count, root } = node
      if (root === true) {
        const menuAttrs = {
          items: [
            {
              label: t('mailbox.folderMenu.foldAll'),
              key: 'collapseAll',
            },
            {
              label: t('mailbox.folderMenu.unfoldAll'),
              key: 'expandAll',
            },
            {
              label: t('common.button.refresh'),
              key: 'refresh',
            },
          ],
          onClick: ({ key, domEvent }: any) => {
            this.onMenuClick('more', key)
            domEvent.stopPropagation()
          },
        }

        const dropdownAttrs = {
          overlayClassName: classNames('contextMenu'),
          menu: menuAttrs,
          trigger: ['click'] as any,
          // onClick: (e) => {
          //   e.stopPropagation()
          // },
        }

        const moreBtn = (
          <OmDropdownMenu {...dropdownAttrs}>
            <OmButton variant="text" icon={<img src={toolbarMore24} alt="more" />} />
          </OmDropdownMenu>
        )

        title = (
          <div className={classNames(styles.departmentItem)}>
            <span>
              {originData.name} ({count})
            </span>
            <span>{moreBtn}</span>
          </div>
        )
      } else {
        title = (
          <div className={classNames(styles.departmentItem)}>
            <span>
              {originData.name} ({count})
            </span>
          </div>
        )
      }
    } else if (originData != null) {
      const { account, display_name: displayName, jobposition: ext_jobposition } = originData.data

      let jobName = ''
      if (this.isJobView === true) {
        const uniqueUserKey = node.key
        const { jobUserMap } = this.treeInfo
        if (jobUserMap) {
          const memberInfo = jobUserMap[uniqueUserKey]

          if (memberInfo != null) {
            const { jobposition, jobtitle } = memberInfo
            if (jobposition?.length > 0 && jobtitle?.length > 0) {
              jobName = `${jobposition} / ${jobtitle}`
            } else {
              jobName = jobposition || jobtitle || ''
            }
          } else if (ext_jobposition?.name?.length > 0) {
            jobName = ext_jobposition.name
          }
        }
      }

      const appendTitle = appendUserTitles != null ? appendUserTitles[account] : null

      const { onDuplicateToPersonal } = this.props
      const treeItemElem = (
        <TreeItem
          displayName={displayName}
          subName={appendTitle}
          account={account}
          jobName={jobName}
          item={originData}
        />
      )

      title =
        onDuplicateToPersonal != null ? (
          <OmDropdownMenu
            menu={{
              items: [
                {
                  key: 'duplicateToPersonal',
                  label: t('contact.menu.duplicateToPersonal'),
                  onClick: () => {
                    const userData = this.getNodeUserData(node.key)
                    if (userData != null) {
                      onDuplicateToPersonal(userData)
                    }
                  },
                },
              ],
            }}
            trigger={['contextMenu']}
            destroyOnHidden
            overlayClassName="contextMenu"
          >
            {treeItemElem}
          </OmDropdownMenu>
        ) : (
          treeItemElem
        )
    }

    return title
  }

  render() {
    const { treeInfo, loading, checkedKeys, expandedKeys, selectedKeys, treeHeight } = this.state
    const { t, enableCheck, hideSearch, enableSelect, excludeEmailList, orgChartTreeClassName } =
      this.props

    let userElems: React.ReactElement | null = null
    if (treeInfo != null) {
      const { treeData, filteredUniqueKeyMap, allDisplayCount } = treeInfo
      const filteredCheckedKeys = checkedKeys.filter((key) => {
        // const userKey = this.getUserKeyByUniqueKey(key)
        return filteredUniqueKeyMap[key] != null
      })

      const treeAttrs = {
        ref: this.treeRef,
        // className: classNames('mailboxTree'),
        switcherIcon: (treeNodeProp: any) => {
          // console.log(' - treeNodeProp', treeNodeProp);
          if (treeNodeProp.expanded === true) {
            return <SVG src={downIcon} />
          }
          return <SVG src={rightIcon} />
        },
        treeData,
        checkable: enableCheck === true,
        // virtual property to false:
        // display: none 항목(excludeEmail, searchText등)이 있을 경우 스크롤에 문제가 있어서 false로 설정
        // 나중에 User가 많으면 최적화 필요. 그때는 구조 변경 필요함.
        virtual: excludeEmailList?.length === 0 && this.searchText === null,
        selectable: true,
        disableMotion: true,
        titleRender: this.titleRender,
        checkedKeys: filteredCheckedKeys,
        expandedKeys,
        selectedKeys,
        height: treeHeight - 16,
        defaultExpandParent: false,
        // defaultExpandAll: true,
        // defaultExpandedKeys: ['0-0-0'],
        // defaultSelectedKeys: ['0-0-0'],
        // defaultCheckedKeys: ['0-0-0'],
        onSelect: (selectedKeys: any, e: any) => {
          if (
            e.nativeEvent.target.tagName.toLowerCase() === 'button' ||
            e.nativeEvent.target.closest('.om-btn')
          ) {
            return null
          }

          console.log('selectedKeys - ', selectedKeys, e)
          const { node } = e
          const { key, type } = node

          if (type === 1) {
            const pos = this.checkedKeys.indexOf(key)
            const checked = pos < 0

            this.setCheckedByKey(node.key, checked)

            if (this.selectedKeys.indexOf(key) < 0) {
              this.onItemClick(key)

              this.selectedKeys = [key]
              this.setState({ selectedKeys: this.selectedKeys })
            }
          } else if (node.type === 0) {
            const pos = this.expandedKeys.indexOf(node.key)
            if (pos > -1) {
              this.expandedKeys.splice(pos, 1)
            } else {
              this.expandedKeys.push(node.key)
            }
            this.setState({ expandedKeys: [...this.expandedKeys] })
            settings.setValue(
              'localSettings.contacts.contactOrganizationExpandedKeys',
              this.expandedKeys,
            )
          }
        },
        onExpand: (exKeys: any, { expanded, node }: any) => {
          console.log('exKeys - ', exKeys, expanded, node)
          this.expandedKeys = exKeys
          this.setState({ expandedKeys: [...this.expandedKeys] })
          settings.setValue(
            'localSettings.contacts.contactOrganizationExpandedKeys',
            this.expandedKeys,
          )
        },
        onCheck: (checkedKeys0: any, { checked, node }: any) => {
          console.log('onCheck - ', checkedKeys0, checked, node)

          let newCheckedKeys = checkedKeys0.filter((key: string) => {
            return key.indexOf('user_') === 0
          })

          if (checked === false) {
            const checkedSet = new Set(this.cantDeselectableKeys)
            newCheckedKeys.forEach((key: string) => {
              checkedSet.add(key)
            })

            newCheckedKeys = Array.from(checkedSet)
          }

          newCheckedKeys = newCheckedKeys.filter((key: string) => {
            return this.cantSelectableKeys.indexOf(key) < 0
          })

          this.checkedKeys = newCheckedKeys

          this.setCheckedByKey(node.key, checked)
        },
      }

      if (allDisplayCount > 0) {
        userElems = <OmTree {...treeAttrs} />
      } else {
        if (this.searchText?.length && this.searchText.length > 0) {
          userElems = <EmptyData type="search" mailbox={null as any} />
        } else {
          userElems = <EmptyData type="contacts" mailbox={null as any} />
        }
      }
    }

    const onChangeBack = (e: any) => {
      console.log('onChangeBack - ', e)
      this.searchText = ''
      this.onSearch(this.searchText)
    }

    let searchElem: React.ReactElement | null = null

    const isMailbox = orgChartTreeClassName != null
    if (hideSearch !== true) {
      const searchAttrs = {
        placeholder: t ? t('email.placeholder.search') : '',
        onSearch: this.onSearch,
        onChange: this.onChange,
        onChangeBack,
        className: isMailbox && styles.mailboxOrgChartSearch,
      }

      searchElem = <Search {...(searchAttrs as any)} />
    }

    const treeCls = {
      enableSelect: enableSelect === true,
      jobView: this.isJobView === true,
    }

    return (
      <div
        className={classNames(styles.orgChartTree, 'orgChartTree', orgChartTreeClassName)}
        data-testid="contacts-org-tree"
        data-loading={loading ? 'true' : 'false'}
      >
        {searchElem}
        <OmSpinner
          className={classNames(styles.loading)}
          spinning={loading}
          data-testid="contacts-org-tree-spinner"
        >
          <div
            className={classNames(styles.tree, 'tree', treeCls)}
            data-testid="contacts-org-tree-content"
            ref={(ref) => {
              this.setRef(ref)
            }}
          >
            {userElems}
          </div>
        </OmSpinner>
      </div>
    )
  }
}

const OrgChartUserList = withTranslation()(OrgChartUserListDef)

export default OrgChartUserList
